import './phone-list-layer.scss';
import React from 'react';
import classnames from 'classnames';
import FormattedMessage from '@/intl/formatted-message';
import muiText from '../../intl/messages/mui';
class PhoneListLayer extends React.Component {
  render() {
    return (
      <div
        className={
          classnames('phone-list-layer', {
            'layer-show': this.props.show,
          })
        }
      >
        <ul
          className={
            classnames('phone-list', {
              'list-show': this.props.show,
            })
          }
        >
          {
            this.props.phoneList.map((item, index) => (
              <li key={index} className="phone-item">
                <a href={`tel:${item}`}>{item}</a>
              </li>
            ))
          }
          <li
            className="phone-item"
          >
            <button
              type="button"
              className="btn-cancel"
              onTouchTap={this.props.closePhoneListLayer}
            ><FormattedMessage {...muiText.muicancel} /></button>
          </li>
        </ul>
      </div>
    );
  }
}

PhoneListLayer.propTypes = {
  phoneList: React.PropTypes.array,
  show: React.PropTypes.bool,
  closePhoneListLayer: React.PropTypes.func,
};

export default PhoneListLayer;



// WEBPACK FOOTER //
// ./src/component/mui/phone-list-layer.jsx